import { GET_RESIDENT_WISE_DELIVERED_COUNT_FAILURE, GET_RESIDENT_WISE_DELIVERED_COUNT_SUCCESS } from '../constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case GET_RESIDENT_WISE_DELIVERED_COUNT_SUCCESS:
            return onSuccess(state, action);
        case GET_RESIDENT_WISE_DELIVERED_COUNT_FAILURE:
            return onFailure(state, action);
        default:
            return { ...state };
    }
};
